<template>
  <div 
    class="TimeLineEvent" 
    :class="classes" 
    :style="styleAttr" 
    @click="activate">
    <span 
      v-if="title !== ''" 
      class="TimeLineEvent__title">
      {{ title }}
    </span> 
    <span 
      class="TimeLineEvent__date">
      {{ dateLabel }}
    </span>
  </div>
</template>

<script>

import {
  convertDateStringToDate,
  verifyDateInput,
  convertDateObjectToDutchMonthYearString
} from '@/helpers/date';
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'TimeLineEvent',
  props: {
    date: {
      type: String,
      required: true,
      validator: verifyDateInput
    },
    start: {
      type: String,
      required: true,
      validator: verifyDateInput
    },
    end: {
      type: String,
      required: true,
      validator: verifyDateInput
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    dateLabel() {
      if (this.label !== '') {
        return this.label;
      }

      return convertDateObjectToDutchMonthYearString(this.dateDate);
    },
    active() {
      return this.date === this.$store.getters.getActivePage;
    },
    classes() {
      let classes = {};
      if (this.active) {
        classes['TimeLineEvent--active'] = true;
      }
      if (this.title !== '') {
        classes['TimeLineEvent--hasTitle'] = true;
      }
      return classes;
    },
    styleAttr() {
      return {
        'left': `${this.offset}`
      }
    },
    dateDate() {
      return convertDateStringToDate(this.date);
    },
    startDate() {
      return convertDateStringToDate(this.start);
    },
    endDate() {
      return convertDateStringToDate(this.end);
    },
    offset() {
      let pos = this.dateDate - this.startDate;
      let range = this.endDate - this.startDate;

      // position items within 5% & 95% of the line width
      return (((pos / range) * 90) + 5) + "%";
    }
  },
  watch: {
    active() {
      this.notifyTimeLineIfActive();
    }
  },
  methods: {
    /**
     * Pass on the activation trigger to the TimeLine component
     */
    activate() {
      this.$store.dispatch('setActiveEvent', {date: this.date});
      VueScrollTo.scrollTo(
        document.querySelector('#section_'+this.date), 
        500, {
          container: document.querySelector('.MainPanelContainer')
        });
    },
    notifyTimeLineIfActive() {
      if (this.active) {
        this.$emit('activated', {offset: this.offset});
      }
    }
  },
  mounted() {
    this.notifyTimeLineIfActive();
  }
}
</script>

<style lang="scss">

  .TimeLineEvent {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 12px;
    cursor: pointer;
    font-size: 14px;
    transition: color .3s;
    width: 120px;
    margin-left: -60px;
    text-align: center;

    &:before {
      content: '';
      position: absolute;
      left: 50%;
      right: auto;
      transform: translateX(-50%);
      height: 12px;
      width: 12px;
      border-radius: 50%;
      border: 2px solid rgba(0, 0, 0, 0.15) !important;
      background-color: #f8f8f8;
      transition: background-color .3s, border-color .3s;
    }
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 30px;
    }

    &:nth-child(2n + 1) {
      top: -25px;
      flex-direction: column-reverse;

      &:before,
      &:after {
        bottom: -14px;
      }
    }
    &:nth-child(2n):before,
    &:nth-child(2n):after {
      top: -17px;
    }
    &--hasTitle:nth-child(2n + 1) {
      top: -45px;
    }

    &:hover {
      color: $color_primary; // #2da798;

      &:before {
        background-color: $color_primary; // #2da798;
        border-color: $color_primary; // #2da798;
      }
    }

    span:first-letter {
      text-transform: capitalize;
    }

    &--active {
      color: $color_primary; //#2da798; // #7b9d6f;

      &:before {
        background-color: $color_primary; // #2da798; // #7b9d6f;
        border-color: $color_primary; // #2da798; // #7b9d6f;
      }
    }
    &__title {
      font-weight: bold
    }
  }

</style>
